import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './unsubscribe.css';
import unsubscribeFromNewsletter from '../API/unsubscribeAPI';

const UnsubscribePage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    const result = await unsubscribeFromNewsletter(email);
    setIsSuccess(result.success);
    setMessage(result.message);
  };

  return (
    <div className="main-banner" id="top">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-6 align-self-center">
                <div className="left-content header-text">
                  <div className="row">
                    <div className="col-lg-12">
                      <h2>Unsubscribe from Our Mailing List</h2>
                      {message ? (
                        <p className={isSuccess ? 'success-message' : 'error-message'}>{message}</p>
                      ) : (
                        <>
                          <p>We're sorry to see you go. Please enter your email address to unsubscribe.</p>
                          <form onSubmit={handleUnsubscribe}>
                            <input 
                              type="email" 
                              placeholder="Enter your email" 
                              value={email} 
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                            <div className="white-button first-button scroll-to-section">
                              <button type="submit">Unsubscribe</button>
                            </div>
                          </form>
                        </>
                      )}
                    </div>
                    <div className="col-lg-12">
                      <div className="white-button first-button scroll-to-section">
                        <Link to="/">Return to Home</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="right-image">
                  <img src={require('../../assets/Images/slider-dec.png')} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsubscribePage;